import React from 'react';
import Modal from 'react-modal';
import RecommendationPage from '../Recommendation';
import {AiOutlineClose} from "react-icons/ai"

const CustomModal = ({ isOpen, onRequestClose }) => {
  const customStyles = {
    content: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      paddingLeft: "60px",
      paddingRight: "60px",
    },
  };
  return (

    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Recommendation Modal"
      style={customStyles}
    >
      <div className='flex justify-end w-full'>
        <AiOutlineClose onClick={onRequestClose} className='text-2xl font-black ml-6 mt-6 hover:text-plaex-bar transition-transform duration-300 ease-in-out transform hover:scale-[0.8]'/>
      </div>
      
      <RecommendationPage  className="-mt-8"/>
    </Modal>
  );
};

export default CustomModal;
